import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const authCookie = Cookies.get('uumail_ut');
      setIsAuthenticated(!!authCookie);
    };

    checkAuth();
    
    // Check auth status when window gains focus
    window.addEventListener('focus', checkAuth);
    return () => window.removeEventListener('focus', checkAuth);
  }, []);

  return { isAuthenticated };
};